export const log =
    process.env.REACT_APP_ENV === 'test' && window.console
        ? console.log
        : function() {};
